export default {
  REDUX_STATE: 'redux_state',
};
